
import { MDCTopAppBar } from '@material/top-app-bar';
import { Vue, Options, Prop } from 'vue-property-decorator';

import MaterialIconButton from './IconButton.vue';

@Options({
    components: {
        MaterialIconButton
    },
})
export default class MaterialTopAppBar extends Vue {

    @Prop(String) readonly title!: string;
    @Prop(Boolean) readonly naviBack?: boolean;

    private ctrl?: MDCTopAppBar;

    mounted() {
        this.ctrl = MDCTopAppBar.attachTo(this.$el);
    }

    updated() {
        this.ctrl?.destroy();
        this.ctrl = MDCTopAppBar.attachTo(this.$el);
    }

    unmounted() {
        this.ctrl?.destroy();
    }
}
